module.exports = __webpack_public_path__ + "media/images/players/KIM_ANTHONY-2ed6b53a5448c9c3e784255f0c62f616.png";